import 'yup_extensions';
import { object as yupObject } from 'yup';
import {
  validationMessages,
  validateArrayMin,
  validateSelection,
  validateStr,
  validateEmail,
  validateNumEmployees,
  validatePhoneNumber,
  validateFirstAndLastName,
} from 'constants/validation_constants';

const {
  atLeastOneMessage,
  selectionMessage,
  invalidCharsMessage,
  companyMessage,
  firstNameMessage,
  lastNameMessage,
  industryMessage,
} = validationMessages;

export const embeddedLeadFormValidationSchema = () => {
  const baseSchema = {
    whoToPay: validateArrayMin(1, atLeastOneMessage),
    whatToUse: validateArrayMin(1, atLeastOneMessage),
    numberStates: validateSelection(selectionMessage),
    prevPayrollProvider: validateSelection(selectionMessage),
    companyName: validateStr(companyMessage, 2)
      .required(companyMessage)
      .noEmailValue(invalidCharsMessage),
    email: validateEmail,
    firstName: validateFirstAndLastName(firstNameMessage).required(firstNameMessage),
    lastName: validateFirstAndLastName(lastNameMessage).required(lastNameMessage),
    numberEmployees: validateNumEmployees,
    phone: validatePhoneNumber(),
    industry: validateStr(industryMessage, 2).required(industryMessage),
  };

  return yupObject().shape(baseSchema);
};

export const embeddedLeadFormHiddenValidationSchema = () => {
  const baseHiddenSchema = {
    whoToPay: validateArrayMin(1, atLeastOneMessage),
    whatToUse: validateArrayMin(1, atLeastOneMessage),
    numberStates: validateSelection(selectionMessage),
    prevPayrollProvider: validateSelection(selectionMessage),
  };

  return yupObject().shape(baseHiddenSchema);
};
